import React, { useState } from "react";
import GetFreeCruise from "./get-free-cruise/Get_Free_Cruise";
import Card_Section from "./card-section/Card_Section";
import Cruise_Description from "./cruise-details/cruise_description/Cruise_Description";
import Success_Modal from "../contact-us/success_modal/Success_Modal";

function Cruises() {
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  return (
    <>
      <GetFreeCruise onClick={() => setShowSuccessModal(true)}/>
      <Card_Section />

      <Success_Modal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        successText="Form Submitted!"
      />
    </>
  );
}

export default Cruises;
